import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { apiClient } from '../../../api/client/axios';
import { showSnackbar } from '../../../store/snackbarSlice';
import { buildListParams } from '../../dataHandlers/queryParams';
import { parseListResponse } from '../../dataHandlers/parseListResponse';

const fetchSubscriptionInvoices = async (query) => {
  const { data } = await apiClient.get('/invoices', { params: query.queryKey[1] });
  return data;
};

export const useGetSubscriptionInvoicesHandler = ({ searchQuery = {} }) => {
  const dispatch = useDispatch();
  const [invoices, setInvoices] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);
  const listParams = buildListParams(searchQuery);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['invoices', listParams],
    queryFn: fetchSubscriptionInvoices,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (data) {
      const { rows, total } = parseListResponse(data);
      setInvoices(rows);
      setTotalDocuments(total);
    }
  }, [data]);

  useEffect(() => {
    if (!isError) return;
    if (error instanceof AxiosError) {
      dispatch(showSnackbar({ message: error.response?.data?.message || error.message, severity: 'error' }));
      return;
    }
    dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
  }, [dispatch, error, isError]);

  return { invoices, totalDocuments, isLoading };
};
